import { businessKey } from 'queryKeys';

export const ASSISTED_INSTALLS = 'assisted-installs';
const aiQuery = businessKey.query(ASSISTED_INSTALLS);

export const mutations = aiQuery.mutations();

export const exportAI = mutations.mutate('export');
